import React from "react";
import "assets/styles/myprofile/style.css";
import MainContent from "components/myprofile";
import { MyProfileProvider } from "context/MyProfileContext"; 

const MyProfile = (props) => {
  return (
    <MyProfileProvider>
      <MainContent />
    </MyProfileProvider>
  );
};

export default MyProfile;
